module.exports = __webpack_public_path__ + "static/media/fly0270.07154ee7.webp";